module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/033-5886cdb460aea6a9c11574bc42f2573f.jpg";